import { testimonials } from "@/mocks/mirrorData";

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div className="relative">
            <div className="overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20of%20stacked%20books%20and%20magazines%20forming%20an%20archive%20tower%2C%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20flat%20art%20style%2C%20subtle%20paper%20grain%2C%20cozy%20and%20inviting%2C%20clean%20composition&width=900&height=1100&seq=about-archive-2026&orientation=portrait"
                alt="本子网站镜像导航的品牌插画，层层叠放的书本与杂志构成档案塔，暖色调"
                className="h-[420px] w-full object-cover md:h-[520px]"
              />
            </div>
            <div className="absolute -bottom-5 right-5 flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-heart-3-line" />
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">超多读者长期收藏</p>
                <p className="text-xs text-foreground-500">一条不断更的路</p>
              </div>
            </div>
          </div>
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-900">
              <i className="ri-book-2-line" /> 关于本站
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              为读者留一条不断更的路
            </h2>
            <p className="mt-5 text-base leading-7 text-foreground-600">
              本站是一个长期维护的镜像导航页，专门汇总本子网站的备用地址与新域名。当原站因网络环境变化无法访问时，这里就是最可靠的备用通道，让你随时回到熟悉的入口继续浏览。
            </p>
            <ul className="mt-6 space-y-3">
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-check-line text-xs" />
                </span>
                <span className="text-sm leading-6 text-foreground-700">
                  入口地址实时检测，状态一目了然，避免逐个尝试浪费时间。
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-check-line text-xs" />
                </span>
                <span className="text-sm leading-6 text-foreground-700">
                  新域名与线路升级优先公布，第一时间获取最新永久入口。
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-check-line text-xs" />
                </span>
                <span className="text-sm leading-6 text-foreground-700">
                  全程免费、无需注册，打开即用，专注解决“找不到入口”的烦恼。
                </span>
              </li>
            </ul>
            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {testimonials.map((t) => (
                <div key={t.id} className="rounded-lg border border-background-200 bg-background-100/60 p-4">
                  <div className="flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs" />
                    <i className="ri-star-fill text-xs" />
                    <i className="ri-star-fill text-xs" />
                    <i className="ri-star-fill text-xs" />
                    <i className="ri-star-fill text-xs" />
                  </div>
                  <p className="mt-3 text-sm leading-6 text-foreground-600">{t.text}</p>
                  <p className="mt-3 text-xs text-foreground-500">
                    {t.name} · {t.role}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}